var $a8674336c84eda04$exports = {};
$a8674336c84eda04$exports = {
    "(optional)": `\u{FF08}\u{53EF}\u{9009}\u{FF09}`,
    "(required)": `\u{FF08}\u{5FC5}\u{586B}\u{FF09}`
};


export {$a8674336c84eda04$exports as default};
//# sourceMappingURL=zh-CN.mjs.map
